import { Component, ChangeDetectorRef, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { finalize } from 'rxjs/operators';
import { Location } from '@angular/common'
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { PlayerListService } from '../../../shared/services/player-list.service';
import { PlayerListDetailsViewModel } from '../../../shared/models/PlayerListModels';
import { CommonModule } from '@angular/common';
import { MaterialModule } from '../../../material/material.module';
import { CdkDragDrop,  CdkDrag, moveItemInArray } from '@angular/cdk/drag-drop';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ConfirmationDialogComponent } from '../../../shared/components/confirmation-dialog/confirmation-dialog.component';
import { SelectSinglePlayerDialogComponent } from '../../../shared/components/select-single-player-dialog/select-single-player-dialog.component';
import { RankingListCopyDialogComponent } from '../../components/ranking-list-copy-dialog/ranking-list-copy-dialog.component';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';

@Component({
    selector: 'app-ranking-list',
    imports: [CommonModule, MaterialModule, RouterModule, TranslateModule],
    templateUrl: './ranking-list.component.html',
    styleUrl: './ranking-list.component.css'
})
export class RankingListComponent implements OnInit {

  _listId: string;
  _list: PlayerListDetailsViewModel | null = null;
  selectedPlayer:string;
  isLoading: boolean = false;
  private listService = inject(PlayerListService);
  private translate = inject(TranslateService);
  private _snackBar = inject(MatSnackBar);
  private cdr = inject(ChangeDetectorRef);
  private destroyRef = inject(DestroyRef);

  constructor(public route: ActivatedRoute,
    public _playerlistService: PlayerListService,
    public location: Location,
    public router: Router,
    public dialog: MatDialog) {
   }

  ngOnInit(): void {
    const listId = this.route.snapshot.paramMap.get('ListId') ?? '';
    this._listId = listId;
    this.getListDetails(listId);
  }

  getListDetails(ListId:string){
    if (this.isLoading) {
      //console.log('Ranking list - already loading, skipping duplicate call');
      return;
    }
    
    this.isLoading = true;
    //console.log('Ranking list - loading details for:', ListId);
    this._playerlistService.getListDetails(ListId)
      .pipe(
        finalize(() => {
          //console.log('Ranking list - finalize, setting isLoading to false');
          this.isLoading = false;
          this.cdr.detectChanges();
        })
      )
      .subscribe({
        next: (res) => {
          this._list = res;
          //console.log('Ranking list - data loaded successfully');
          this.cdr.detectChanges();
          ////console.log(res);
        },
        error: (err) => {
          //console.error('Error loading ranking list details:', err);
        }
      });
  }

  deleteList() {
    if (!this._list || !(this._list.IsMyList || this._list.CanEdit)) {
      return;
    }

    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: '350px',
      data: "Do you want to delete the list '" + this._list.Description + "' owned by '" + this._list.CreatedBy + "'?"
    });

    dialogRef.afterClosed()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(result => {
        if (result && this._list) {
          //console.log(TestResultId);
          this._playerlistService.deleteList(this._list.ListId)
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe(result => {
              if (result) {
                this.router.navigate(['/lists']);
              }
            });
          //Notify about delete

        }
      });

  }

  archiveList() {
    if (!this._list || !(this._list.IsMyList || this._list.CanEdit)) {
      return;
    }

    var message: string;
    message = this.translate.instant("RANKINGLISTS.CONFIRM_ARCHIVELIST", { listname: this._list.Description });


    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: '350px',
      data: message
    });

    dialogRef.afterClosed()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(result => {

        if (result && this._list) {
          this.listService.archiveList(this._list.ListId)
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe(success => {
              if (success) {
                this.openSnackBar('Archived successfully', 'Close')
                //this.hiddenLists.push(List.ListId);
                this.router.navigate(['/lists']);
              } else {
                this.openSnackBar('Archive failed', 'Close')
              }

            });

        } else {
          this.openSnackBar('Archive cancelled', 'Close')
        }

      });
  }


  unarchiveList() {
    if (!this._list || !(this._list.IsMyList || this._list.CanEdit)) {
      return;
    }

    var message: string;
    message = this.translate.instant("RANKINGLISTS.CONFIRM_UNARCHIVELIST", { listname: this._list.Description });


    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: '350px',
      data: message
    });

    dialogRef.afterClosed()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(result => {

        if (result && this._list) {
          this.listService.unarchiveList(this._list.ListId)
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe(success => {
              if (success) {
                this.openSnackBar(this.translate.instant("RANKINGLISTS.LIST_RESTORED"), this.translate.instant("GENERAL.CLOSE"))
                //this.hiddenLists.push(List.ListId);
                this.router.navigate(['/lists']);
              } else {
                this.openSnackBar(this.translate.instant("RANKINGLISTS.RESTORE_FAILED"), this.translate.instant("GENERAL.CLOSE"))
              }

            });

        } else {
          this.openSnackBar(this.translate.instant("RANKINGLISTS.RESTORE_CANCELLED"), this.translate.instant("GENERAL.CLOSE"))
        }

      });
  }

  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, { duration: 2000 });
  }



  copyList() {
    if (!this._list) {
      return;
    }

    const dialogRef = this.dialog.open(RankingListCopyDialogComponent, {
      width: '350px',
      data: {
        CopyFromListId: this._list.ListId,
        CopyFromCategory: this._list.Category,
        CopyFromListName: this._list.Description,

      }
    });

    dialogRef.afterClosed()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(result => {
        // console.log(result);
  /* if(result){
    this.openSnackBar('Copied successfully', 'Close')
    this.getData();
  }else{
    this.openSnackBar('Copy failed', 'Close')
  } */

    });
  }




   
  drop(event: CdkDragDrop<string[]>) {
    if (!this._list || !(this._list.IsMyList || this._list.CanEdit)) return;
    
    //console.log(event);
    this._playerlistService.MovePlayerInList(this._list.ListId, this._list.players[event.previousIndex].Player.LifelineScoutingId, event.previousIndex, event.currentIndex)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(res=>{
        //console.log("Test");
        if(res && this._list){
          moveItemInArray(this._list.players, event.previousIndex, event.currentIndex);
          this.cdr.detectChanges();
        }
      });
        
  }

  addPlayer(){
    if (!this._list || !(this._list.IsMyList || this._list.CanEdit)) return;
    
    const confirmDialog = this.dialog.open(SelectSinglePlayerDialogComponent, {
      data: {
        Action: 'ADD'
        
      }
    });
    confirmDialog.afterClosed()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(result => {
        if (!this._list || !result) return;

        this._playerlistService.addPlayerInList(this._list.ListId, result.SelectedPlayer)
          .pipe(takeUntilDestroyed(this.destroyRef))
          .subscribe(res => {
            if(res && this._list)
              this.getListDetails(this._list.ListId);
          });
       
      });
  }

  confirmDelete(player: string){
    if (!this._list || !(this._list.IsMyList || this._list.CanEdit)) return;
    
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: '350px',
      data: "Do you want to remove the player?"
    });

    dialogRef.afterClosed()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(result => {
        if(result && this._list) {
          //console.log(TestResultId);
          this._playerlistService.deletePlayerInList(this._list.ListId,player)
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe(result => {
              if (this._list)
                this.getListDetails(this._list.ListId);
            });
          //Notify about delete
          
        }
      });
    //console.log(player);
  }

}
